import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { ArbeitsbereichKalenderStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class Arbeitsbereich {
  constructor({
    markierung,
    name,
    stationen,
    id,
  }: {
    markierung: Markierung;
    name: string;
    stationen?: ArbeitsbereichKalenderStation[];
    id: string;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.stationen = stationen;
    this.id = id;
  }

  id: string;
  markierung: Markierung;
  name: string;
  stationen?: ArbeitsbereichKalenderStation[];

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }
}
